export default __webpack_public_path__ + "static/media/bauhaus-left.0b655787.svg";